<eca-app-shell>
  <eca-left-nav
    [links]="links$"
    [opened]="true"
  >
    <router-outlet></router-outlet>
  </eca-left-nav>
</eca-app-shell>
